/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Button } from "antd";
import CarSwapModal from "../../modals/CarSwap/CarSwapModal";
import { useToast } from "../../../../../contexts/ToastContext";
import {
    notifyRejectReservationError,
    notifyRejectReservationSuccess,
} from "../utils/rejectReservationToasts";
const ConfirmReject = ({
    resDetails,
    setResDetails,
    match,
    firestore,
    apiClient,
    isRejecting,
    setIsRejecting,
    isLoading,
    rejectReservation,
    onCarSwapSuccess,
    t,
}) => {
    const toast = useToast();
    const [openSwapModal, setOpenSwapModal] = useState(false);

    // Condition 1: Not approved, car linked, not rejected, not cancelled
    const showApprovalWithLinkedCar =
        resDetails &&
        resDetails.isApproved === false &&
        resDetails.isCarLinked === true &&
        resDetails.isRejected === false &&
        resDetails.isCancelled === false;

    // Condition 2: Not approved, car not linked, not rejected, car not selected, not cancelled
    const showApprovalWithoutLinkedCar =
        resDetails &&
        resDetails.isApproved === false &&
        resDetails.isCarLinked === false &&
        resDetails.isRejected === false &&
        resDetails.isCarSelected === false &&
        resDetails.isCancelled === false;

    // Condition 3: Reservation is rejected
    const showRejectedStatus = resDetails && resDetails.isRejected;

    // Condition 4: Approved, car linked, car not selected, not cancelled
    const showApprovedWithLinkedCar =
        resDetails &&
        resDetails.isApproved &&
        resDetails.isCarLinked &&
        resDetails.isCarSelected === false &&
        resDetails.isCancelled === false;

    // Condition 5: Approved, car linked, car selected, door not unlocked, not cancelled, not rejected, flag is true
    const showCarSelectedState =
        resDetails &&
        resDetails.isApproved &&
        resDetails.isCarLinked &&
        resDetails.isCarSelected &&
        resDetails.isDoorUnlockedRequested === false &&
        resDetails.isCancelled === false &&
        resDetails.isRejected === false &&
        resDetails.flag;

    // Condition 6: Door unlock requested but not approved
    const showDoorUnlockRequest =
        resDetails &&
        resDetails.isApproved &&
        resDetails.isCarLinked &&
        resDetails.isCarSelected &&
        resDetails.isDoorUnlockedRequested &&
        resDetails.isDoorUnlockedApproved === false &&
        resDetails.isCancelled === false;

    // Condition 7: Car not selected, need to show car selection option
    const showCarNotSelected =
        resDetails &&
        resDetails.isApproved &&
        resDetails.isCarLinked === false &&
        resDetails.isCarSelected === false &&
        resDetails.isDoorUnlockedRequested === false &&
        resDetails.isCarPickedUp === false &&
        resDetails.isRejected === false &&
        resDetails.isCancelled === false;

    return (
        <>
            {/* Condition 1: Approval with linked car */}
            {showApprovalWithLinkedCar && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.linkCarApprove")}
                    </p>
                    <div className="mt-4 flex h-10 w-full gap-2">
                        <Button
                            type="primary"
                            shape="round"
                            className="flex-[2]"
                            onClick={async () => {
                                try {
                                    const res = await apiClient.patch(`/api/reservation/${match.params.id}`, {
                                        isApproved: true,
                                    });

                                    if (res?.data?.success) {
                                        setResDetails((prev) => ({
                                            ...prev,
                                            isApproved: true,
                                        }));

                                        toast.success({ message: t("resDetails.reservationApproved") });
                                    }
                                } catch (error) {
                                    console.error("Error : ", error?.response?.data || error);
                                    toast.error({ message: t("resDetails.couldNotApprove") });
                                }
                            }}>
                            {t("resDetails.approve")}
                        </Button>
                        <Button
                            color="danger"
                            variant="solid"
                            shape="round"
                            className="flex-1"
                            onClick={async () => {
                                try {
                                    const res = await apiClient.post("/api/past-reservation/create", {
                                        ...resDetails,
                                        category: resDetails?.category?._id
                                            ? String(resDetails.category._id)
                                            : resDetails?.category,
                                        isRejected: true,
                                    });
                                    if (res?.data?.success) {
                                        setResDetails((prev) => ({
                                            ...prev,
                                            isRejected: true,
                                            flag: false,
                                        }));

                                        notifyRejectReservationSuccess(toast, t);
                                    }
                                } catch (error) {
                                    console.error("Error : ", error?.response?.data || error);
                                    notifyRejectReservationError(toast, t, error);
                                }
                            }}>
                            {t("resDetails.reject")}
                        </Button>
                    </div>
                    <footer
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}>
                        <label
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            {t("resDetails.linkCars")}:
                        </label>
                        <Button shape="round" disabled title={t("resDetails.pleaseApprove")} className="!w-32">
                            {t("resDetails.confirm")}
                        </Button>
                    </footer>
                </>
            )}

            {/* Condition 2: Approval without linked car */}
            {showApprovalWithoutLinkedCar && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.linkCarApprove")}
                    </p>

                    <header
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}>
                        <label
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            {t("resDetails.linkCars")}:
                        </label>
                    </header>
                    <div className="mt-4 flex h-10 w-full gap-2">
                        <Button
                            type="primary"
                            shape="round"
                            className="flex-[2]"
                            onClick={async () => {
                                try {
                                    const res = await apiClient.patch(`/api/reservation/${match.params.id}`, {
                                        isApproved: true,
                                    });

                                    if (res?.data?.success) {
                                        setResDetails((prev) => ({
                                            ...prev,
                                            isApproved: true,
                                        }));

                                        toast.success({ message: t("resDetails.reservationApproved") });
                                    }
                                } catch (error) {
                                    console.error("Error : ", error?.response?.data || error);
                                    toast.error({ message: t("resDetails.couldNotApprove") });
                                }
                            }}>
                            {t("resDetails.approve")}
                        </Button>
                        <Button
                            color="danger"
                            variant="solid"
                            shape="round"
                            className="flex-1"
                            onClick={async () => {
                                try {
                                    const res = await apiClient.post("/api/past-reservation/create", {
                                        ...resDetails,
                                        category: resDetails?.category?._id
                                            ? String(resDetails.category._id)
                                            : resDetails?.category,
                                        isRejected: true,
                                    });
                                    if (res?.data?.success) {
                                        setResDetails((prev) => ({
                                            ...prev,
                                            isRejected: true,
                                            flag: false,
                                        }));

                                        notifyRejectReservationSuccess(toast, t);
                                    }
                                } catch (error) {
                                    notifyRejectReservationError(toast, t, error);
                                }
                            }}>
                            {t("resDetails.reject")}
                        </Button>
                    </div>
                </>
            )}

            {/* Condition 3: Rejected status */}
            {showRejectedStatus && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.reservationRejectedByAdmin")}
                    </p>
                    <section
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}
                    />
                </>
            )}

            {/* Condition 4: Approved with linked car */}
            {showApprovedWithLinkedCar && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.reservationApprovedByAdmin")}
                    </p>
                    <section
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}>
                        <p
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            {t("resDetails.carLinked")}:{" "}
                            {resDetails?.carLinked?.map((x, ind) =>
                                ind < resDetails.carLinked.length - 1 ? `${x?.name}, ` : x?.name,
                            )}
                        </p>
                        <Button
                            color="danger"
                            variant="solid"
                            shape="round"
                            block
                            loading={isRejecting}
                            className="!mt-2 !h-11 max-w-md"
                            onClick={() => {
                                if (typeof rejectReservation === "function") {
                                    rejectReservation();
                                }
                            }}>
                            {isRejecting
                                ? t("resDetails.rejectingReservation")
                                : t("resDetails.rejectReservation")}
                        </Button>
                    </section>
                </>
            )}

            {/* Condition 5: Car selected state or Condition 7: Car not selected */}
            {/* These conditions only applicable for upcoming reservation */}
            {(showCarSelectedState || showCarNotSelected) && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.reservationApprovedByAdmin")}
                    </p>
                    <article
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}>
                        <p
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            <strong
                                style={{
                                    fontWeight: "bold",
                                    marginRight: "5px",
                                }}>
                                {t("resDetails.carSelected")}:
                            </strong>
                            {resDetails?.carSelected?.name || resDetails?.carSelected?.carName || "N/A"}
                        </p>
                        {resDetails.isDoorUnlockedRequested === false &&
                            resDetails.isCarPickedUp === false &&
                            resDetails.isRejected === false &&
                            resDetails.isCancelled === false && (
                                <>
                                    <div className="mt-2 flex w-full max-w-md flex-col gap-3">
                                        <Button
                                            type="primary"
                                            shape="round"
                                            block
                                            loading={isLoading}
                                            className="!h-11"
                                            onClick={() => !isLoading && setOpenSwapModal(true)}>
                                            {isLoading
                                                ? t("resDetails.swappingCar")
                                                : resDetails.carSelected
                                                  ? t("resDetails.confirmCarSwap")
                                                  : t("resDetails.selectCar")}
                                        </Button>
                                        <Button
                                            color="danger"
                                            variant="solid"
                                            shape="round"
                                            block
                                            loading={isRejecting}
                                            className="!h-11"
                                            onClick={rejectReservation}>
                                            {isRejecting
                                                ? t("resDetails.rejectingReservation")
                                                : t("resDetails.rejectReservation")}
                                        </Button>
                                    </div>
                                </>
                            )}
                    </article>
                </>
            )}

            {/* Condition 6: Door unlock request */}
            {showDoorUnlockRequest && (
                <>
                    <p
                        className="fontRegular"
                        style={{
                            color: "#acacb9",
                            fontSize: "0.9rem",
                            marginTop: "1.4rem",
                        }}>
                        {t("resDetails.pleaseUnlockDoor")}
                    </p>

                    <header
                        className="fontRegular"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            alignItems: "center",
                        }}>
                        <p
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            {t("resDetails.carSelected")}: {resDetails.carSelected?.name}
                        </p>
                    </header>
                    <div className="mt-4 flex h-10 w-full gap-2">
                        <Button
                            type="primary"
                            shape="round"
                            className="flex-[3]"
                            onClick={async () => {
                                const response = await axios.put("https://apicarapp.herokuapp.com/unlockCar", {
                                    serialNumber: resDetails.carSelected.sn.toString(),
                                });
                                console.log(response.data);
                                firestore.collection("Reservations").doc(match.params.id).update({
                                    isDoorUnlockApprove: true,
                                    isDoorUnlockRequest: false,
                                    isCarPickedUp: true,
                                });
                                window.location.reload(false);
                            }}
                            onKeyUp={async (e) => {
                                if (e.key === "Enter") {
                                    const response = await axios.put("https://apicarapp.herokuapp.com/unlockCar", {
                                        serialNumber: resDetails.carSelected.sn.toString(),
                                    });
                                    console.log(response.data);
                                    firestore.collection("Reservations").doc(match.params.id).update({
                                        isDoorUnlockApprove: true,
                                        isDoorUnlockRequest: false,
                                        isCarPickedUp: true,
                                    });
                                    window.location.reload(false);
                                }
                            }}>
                            {t("resDetails.unlockDoor")}
                        </Button>
                    </div>
                </>
            )}

            <CarSwapModal
                isOpen={openSwapModal}
                setIsOpen={setOpenSwapModal}
                resDetails={resDetails}
                onCarSwapSuccess={onCarSwapSuccess}
                setResDetails={setResDetails}
            />
        </>
    );
};

ConfirmReject.propTypes = {
    resDetails: PropTypes.object,
    setResDetails: PropTypes.func,
    match: PropTypes.object,
    firestore: PropTypes.object,
    apiClient: PropTypes.object,
    axios: PropTypes.object,
    isRejecting: PropTypes.bool,
    setIsRejecting: PropTypes.func,
    isLoading: PropTypes.bool,
    rejectReservation: PropTypes.func,
    onCarSwapSuccess: PropTypes.func,
    t: PropTypes.func,
};

export default ConfirmReject;
